import { useMutation } from '@tanstack/react-query';
import { repo } from 'index';

export const useEnterpriseDriverDelete = () => {
  const { mutateAsync, status } = useMutation({
    mutationFn: repo.deleteEnterpriseDriver,
  });

  return {
    deleteEnterpriseDriverMutateAsync: mutateAsync,
    deleteEnterpriseDriverStatus: status,
  };
};
